import React from "react";
export class DemoComponent extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return /*#__PURE__*/React.createElement("span", null, "Demo Content");
  }
}